import React, { useEffect, useRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import axios from "../../API/axios";
import UpdateCompany from "../CreateCompany/UpdateCompany";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import MoreHorizSharpIcon from '@mui/icons-material/MoreHorizSharp';
import UpdateSharpIcon from '@mui/icons-material/UpdateSharp';
import DeleteOutlineSharpIcon from '@mui/icons-material/DeleteOutlineSharp';
import DisabledByDefaultSharpIcon from '@mui/icons-material/DisabledByDefaultSharp';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { useTranslation } from "react-i18next";
import { Portal } from "../../components/Portal";

const CompanyActions = ({ showUpdateModal,handleOpenUpdate,handleClose, setShow,show, setShowUpdateModal, compUid,  getCompanyList, item,openDeleteModal,closeDeleteModal, setDeleteModal,deleteModal, onCompanyDeleted, renderDialogs = true, onSuccessToast, onWarningToast, onErrorToast }) => {
  const sessionId = localStorage.getItem("sessionId");
  const [showDropdown, setShowDropdown] = useState(false);
  const language = localStorage.getItem("Lang");

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const { t } = useTranslation();
  const closeDropdown = () => setShowDropdown(false);
  const menuRootRef = useRef(null);
  const dropdownRef = useRef(null);

  const notifySuccess = (message) => {
    if (onSuccessToast) {
      onSuccessToast(message);
      return;
    }
    setToastMessage(message);
    setShowToast(true);
  };

  const notifyWarning = (message) => {
    if (onWarningToast) {
      onWarningToast(message);
      return;
    }
    setWarningToastMessage(message);
    setShowWarningToast(true);
  };

  const notifyError = (message) => {
    if (onErrorToast) {
      onErrorToast(message);
      return;
    }
    setErrorToastMessage(message);
    setShowErrorToast(true);
  };

  const stopBubble = (event) => {
    event.stopPropagation();
  };

  const runMenuAction = (event, action) => {
    event.preventDefault();
    event.stopPropagation();
    closeDropdown();
    action?.();
  };

  const handleClickOutside = (event) => {
    if (menuRootRef.current && !menuRootRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Company/DeleteCompany

  //************************Remove Skill start  ************************//
  // const [compUid, setCompUid] = useState('');
  // const [show, setShow] = useState(false);
  const handleRemoveSkillClose = () => {
    setShow(false);
  };

  const openUpdateModal = () => {
    setShowUpdateModal(true);
  };
  const closeUpdateModal = () => {
    setShowUpdateModal(false);
  };

  const [skillId, setSkillId] = useState("");

  const deleteCompany = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      compUid,
      langKey: language === "en" ? "" : language,

    };
    try {
      await axios.post(`Company/DeleteCompany`, responseData).then((res) => {
        console.log(res.data);
        // setShow(!show);
        closeDeleteModal();
        notifySuccess(res.data.message);
        onCompanyDeleted?.(compUid);
        getCompanyList?.({ showLoading: false, forceRefresh: true });
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        notifyWarning(e.response?.data?.message);
      } else {
        notifyError(e.response?.data?.message);
      }
    }
  };

  //************************Remove Skill End  ************************//

  const DisableCompany = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      compUid,
      langKey: language === "en" ? "" : language,

    };
    try {
      await axios.post(`Company/DisableCompany`, responseData).then((res) => {
        console.log(res.data);
        notifySuccess(res.data.message);
        getCompanyList?.({ showLoading: false, forceRefresh: true });
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        notifyWarning(e.response?.data?.message);
      } else {
        notifyError(e.response?.data?.message);
      }
    }
  };
  const EnableCompany = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      compUid,
      langKey: language === "en" ? "" : language,

    };
    try {
      await axios.post(`Company/EnableCompany`, responseData).then((res) => {
        console.log(res.data);
        notifySuccess(res.data.message);
        getCompanyList?.({ showLoading: false, forceRefresh: true });
      });
      
    } catch (e) {
      if (e.response && e.response.status === 404) {
        notifyWarning(e.response?.data?.message);
      } else {
        notifyError(e.response?.data?.message);
      }
    }
  };

  // useEffect(() => {
  //   if (show) {
  //     document.body.style.overflow = 'hidden';
  //     document.documentElement.style.overflow = 'hidden';
  //     document.body.classList.add('modal-open'); // When a modal opens
  //   } else {
  //     document.body.style.overflow = 'unset';
  //     document.documentElement.style.overflow = '';
  //     document.body.classList.remove('modal-open'); // When a modal closes
  //   }
  // }, [show]);


  const [companyDetails, setCompanyDetails] = useState(item || "");

  useEffect(() => {
    if (item) {
      setCompanyDetails(item);
    }
  }, [item]);

  const CompanyDetails = async () => {
    try {
      const result = await axios.post(`Company/GetCompanyDetails`, {
        deviceType: "Web",
        compUid: compUid,
        langKey: language === "en" ? "" : language,
      });

      const Response = result?.data?.responseData;
      setCompanyDetails(Response);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleUpdateCompanyClick = (event) => {
    runMenuAction(event, () => {
      handleOpenUpdate(compUid);
      CompanyDetails();
    });
  };

  useEffect(() => {
    if (renderDialogs && showUpdateModal === item?.compUid && compUid) {
      CompanyDetails();
    }
  }, [showUpdateModal, renderDialogs, compUid]);

  return (
    <>
      <div
        ref={menuRootRef}
        className={`postMenu pointer${showDropdown ? " is-open" : ""}`}
        onMouseDown={(event) => event.stopPropagation()}
        onClick={(event) => event.stopPropagation()}
      >
        <MoreHorizSharpIcon
          className="material-symbols-sharp mycompanyAction"
          onClick={(event) => {
            stopBubble(event);
            setShowDropdown((open) => !open);
          }}
        />
        {showDropdown && (
          <Dropdown.Menu
            show={showDropdown}
            ref={dropdownRef}
            className="InteractionModal wlj-company-action-menu"
            onMouseDown={stopBubble}
            onClick={stopBubble}
          >
            <Dropdown.Item
              as="button"
              className="dropdownList"
              onMouseDown={stopBubble}
              onClick={handleUpdateCompanyClick}
            >
              <div className="d-flex align-items-center">
                <UpdateSharpIcon className="material-symbols-sharp me-2" />
                <span className="dropdownTxt f-14">{t("Manage Companies.Update Company")}</span>
              </div>
            </Dropdown.Item>
            <Dropdown.Item
              as="button"
              className="dropdownList"
              onMouseDown={stopBubble}
              onClick={(event) => runMenuAction(event, () => openDeleteModal(compUid))}
            >
              <div className="d-flex align-items-center">
                <DeleteOutlineSharpIcon className="material-symbols-sharp me-2" />
                <span className="dropdownTxt f-14 redText">{t("Manage Companies.Delete Company")}</span>
              </div>
            </Dropdown.Item>
            {item?.status === 1 ? (
              <Dropdown.Item
                as="button"
                className="dropdownList"
                onMouseDown={stopBubble}
                onClick={(event) => runMenuAction(event, DisableCompany)}
              >
                <div className="d-flex align-items-center">
                  <DisabledByDefaultSharpIcon className="material-symbols-sharp me-2" />
                  <span className="dropdownTxt f-14">{t("Manage Companies.Disable Company")}</span>
                </div>
              </Dropdown.Item>
            ) : (
              <Dropdown.Item
                as="button"
                className="dropdownList"
                onMouseDown={stopBubble}
                onClick={(event) => runMenuAction(event, EnableCompany)}
              >
                <div className="d-flex align-items-center">
                  <DisabledByDefaultSharpIcon className="material-symbols-sharp me-2" />
                  <span className="dropdownTxt f-14">{t("Manage Companies.Enable Company")}</span>
                </div>
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
        )}
      </div>


      {/* {show && ( */}
      {renderDialogs && deleteModal=== item.compUid && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd wlj-overlay-modal"
          tabIndex="-1"
          role="dialog"
          style={{ display: "flex" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2" onClick={(e) => e.stopPropagation()}>
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6 className="wlj-modal-title--danger">
                  <DeleteOutlineSharpIcon className="material-symbols-sharp" />
                  {t("User Profile.Are You Sure You want to Delete?")}
                </h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    closeDeleteModal();
                  }}
                />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => deleteCompany()}
                >
                  {t("Drafts.Delete")}
                </button>
              </div>
            </div>
          </div>
        </div>
        </Portal>
      )}

    {renderDialogs && showUpdateModal=== item.compUid && (
      <UpdateCompany 
        showUpdateModal={showUpdateModal}
        closeUpdateModal={handleClose}
        compUid={compUid}
        getCompanyList={getCompanyList}
        companyDetails={companyDetails}
        setCompanyDetails={setCompanyDetails}
      />
    )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default CompanyActions;
